import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AgGridModule } from 'ag-grid-angular';
import { provideGlobalGridOptions } from 'ag-grid-community';
// Provide global grid options here
provideGlobalGridOptions({
  theme: 'legacy',
});

if (environment.production) {
  enableProdMode();
}



import { LicenseManager} from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(environment.agGridLicenseKey);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.info(err)); // NOSONAR